import { attemptFocus } from './attempt-focus.js';

/**
 * @internal
 *
 * Set focus on descendant nodes until the first focusable element is found.
 * @param element - DOM node for which to find the first focusable descendant.
 * @param options - Options to determine if the focus ring should be shown.
 * @returns true if a focusable element is found and focus is set.
 */
export const focusFirstDescendant = (
  element: HTMLElement | null,
  options?: { focusVisible?: boolean },
) => {
  if (!element) {
    return false;
  }

  for (const child of element.children) {
    const childElement = child as HTMLElement;
    if (
      attemptFocus(childElement, options) ||
      focusFirstDescendant(childElement, options)
    ) {
      return true;
    }
  }

  return false;
};
